
export default {
  name: 'AppNoContent',
}
